var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6668 8.00001C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00001C1.3335 4.31811 4.31826 1.33334 8.00016 1.33334C11.6821 1.33334 14.6668 4.31811 14.6668 8.00001ZM8.00016 6.00001C8.36835 6.00001 8.66683 5.70153 8.66683 5.33334C8.66683 4.96515 8.36835 4.66668 8.00016 4.66668C7.63197 4.66668 7.3335 4.96515 7.3335 5.33334C7.3335 5.70153 7.63197 6.00001 8.00016 6.00001ZM8.00016 7.00001C7.72402 7.00001 7.50016 7.22387 7.50016 7.50001V10.5C7.50016 10.7762 7.72402 11 8.00016 11C8.27631 11 8.50016 10.7762 8.50016 10.5V7.50001C8.50016 7.22387 8.27631 7.00001 8.00016 7.00001Z",
    fill: "#FF9322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.255367894b55eb86b3f1b0af4d70630b.svg";
export { ForwardRef as ReactComponent };